import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const TransactionsMain = lazy(() => import('../tx/TransactionsMain'));
const InjuredInactiveRehab = lazy(
  () => import('../tx/InjuredInactiveRehab/InjuredInactiveRehab')
);
const TaxiSquad = lazy(() => import('../tx/TaxiSquad/TaxiSquad'));
const PlayerTracking = lazy(
  () => import('../tx/PlayerTracking/PlayerTracking')
);

export default [
  {
    id: NavConfig.groupConfigs.TRANSACTIONS.id,
    path: NavConfig.groupConfigs.TRANSACTIONS.to,
    element: (
      <TransactionsMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </TransactionsMain>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate to={NavConfig.linkConfigs.TX_INJURED_INACTIVE_REHAB.to} />
        ),
      },
      {
        id: NavConfig.linkConfigs.TX_INJURED_INACTIVE_REHAB.id,
        path: NavConfig.linkConfigs.TX_INJURED_INACTIVE_REHAB.to,
        element: <InjuredInactiveRehab />,
      },
      {
        id: NavConfig.linkConfigs.TX_TAXI_SQUAD.id,
        path: NavConfig.linkConfigs.TX_TAXI_SQUAD.to,
        element: <TaxiSquad />,
      },
      {
        id: NavConfig.linkConfigs.TX_PLAYER_TRACKING.id,
        path: NavConfig.linkConfigs.TX_PLAYER_TRACKING.to,
        element: <PlayerTracking />,
      },
    ],
  },
];
